export const VIEW_MODES = {
  LIST: 'list',
  PROJECT_DETAILS: 'project-details',
};

export const PROJECT_RENAME_DEBOUNCE_MS = 600;
